
import { Helmet } from "react-helmet-async";
import React from "react";
import CidadeSchemas from "./CidadeSchemas";

interface CidadeSEOProps {
  cidade: string;
  cidadeFormatted: string;
  estadoNome: string;
  estado: string;
  faqItems: Array<{
    question: string;
    answer: string;
  }>;
}

const CidadeSEO = ({ cidade, cidadeFormatted, estadoNome, estado, faqItems }: CidadeSEOProps) => {
  // Ensure canonical URL is correctly set for the current city
  const currentUrl = `https://www.localup.com.br/cidade/local/${cidade}`;

  // Get all schemas from the CidadeSchemas component
  const { faqSchema, serviceSchema, localBusinessSchema, breadcrumbSchema } = 
    CidadeSchemas({ faqItems, cidadeFormatted, estadoNome, currentUrl, estado });

  return (
    <Helmet prioritizeSeoTags>
      {/* Title and Meta Tags */}
      <title>SEO Local em {cidadeFormatted} - {estadoNome} | LocalUp</title>
      <meta 
        name="description" 
        content={`Serviços de SEO Local em ${cidadeFormatted}, ${estadoNome}. Aumente sua visibilidade no Google e atraia mais clientes locais em ${cidadeFormatted} através de estratégias personalizadas de marketing digital.`} 
      />
      <meta 
        name="keywords" 
        content={`SEO Local ${cidadeFormatted}, Marketing Digital ${cidadeFormatted}, Google Meu Negócio ${cidadeFormatted}, SEO ${estadoNome}, SEO ${cidadeFormatted}, Ranking Local ${cidadeFormatted}`} 
      />
      <link rel="canonical" href={currentUrl} />
      <meta property="og:title" content={`SEO Local em ${cidadeFormatted} - ${estadoNome} | LocalUp`} />
      <meta property="og:description" content={`Serviços de SEO Local em ${cidadeFormatted}, ${estadoNome}. Aumente sua visibilidade no Google e atraia mais clientes da região com nossa consultoria especializada.`} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content="https://www.localup.com.br/images/seo-local-social-card.jpg" />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="pt_BR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`SEO Local em ${cidadeFormatted} - ${estadoNome} | LocalUp`} />
      <meta name="twitter:description" content={`Estratégias de SEO Local para empresas em ${cidadeFormatted}`} />
      <meta name="twitter:image" content="https://www.localup.com.br/images/seo-local-social-card.jpg" />
      <meta name="robots" content="index, follow" />
      <meta name="geo.region" content={`BR-${estado}`} />
      <meta name="geo.placename" content={cidadeFormatted} />
      
      {/* FAQ Schema */}
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      
      {/* Service Schema */}
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
      
      {/* LocalBusiness Schema */}
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      
      {/* Breadcrumb Schema */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default CidadeSEO;
